const moneyFmt = new Intl.NumberFormat('th-TH', {
  style: 'currency',
  currency: 'THB',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function money(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—'
  return moneyFmt.format(n)
}

export function moneyPlain(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—'
  return n.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString('th-TH', {
      dateStyle: 'medium',
      timeStyle: 'short',
    })
  } catch {
    return iso ?? '—'
  }
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleDateString('th-TH', { dateStyle: 'medium' })
  } catch {
    return iso ?? '—'
  }
}

export function paymentLabel(m: string | null | undefined): string {
  switch (m) {
    case 'cash':
      return 'เงินสด'
    case 'qr':
      return 'QR พร้อมเพย์'
    case 'card':
      return 'บัตรเครดิต/เดบิต'
    case 'transfer':
      return 'โอนเข้าบัญชี'
    default:
      return '—'
  }
}
